import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import {
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  type TooltipContentProps,
  XAxis,
  YAxis,
} from "recharts"

import { useLecturesDegreesStats } from "@/queries/queries"

import stayle from "./BarCharts.module.css"

const chartDot = (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7" cy="7.5" r="7" fill="#F15824" />
  </svg>
)

const CustomTooltip = ({
  active,
  payload,
  label,
}: TooltipContentProps<string | number, string>) => {
  if (active && payload && payload.length) {
    const { lecture_date } = payload[0].payload
    const dateFormatted = lecture_date
      ? new Date(lecture_date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "N/A"

    return (
      <div
        className={stayle["custom-tooltip"]}
        style={{
          padding: "10px 14px", // زيادة الترايح
          borderRadius: "8px",
        }}
      >
        <p className={stayle["tooltip-label"]}>{label}</p>
        <p className={stayle["tooltip-value"]}>
          {chartDot}
          {payload[0].value}
          <span>{payload[0].payload.label}</span>
        </p>
        <p
          style={{
            margin: "4px 0 0",
            fontSize: "12px",
            color: "#888",
          }}
        >
          📅 {dateFormatted}
        </p>
      </div>
    )
  }
  return null
}

const BarChart = () => {
  const { data: lecData } = useLecturesDegreesStats()

  const { t } = useTranslation()

  const chartData = useMemo(() => {
    if (!lecData) return []

    return Object.entries(lecData).map(([name, value]) => ({
      name,
      students: value?.degrees ?? 0, // قراءة الدرجة
      label: t("homePage.leaderboard.barchart.label"),
      lecture_date: value?.lecture_date || null, // حفظ التاريخ للـ tooltip
    }))
  }, [lecData])

  return (
    <div className={stayle["main-com"]}>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart
          data={chartData}
          margin={{
            top: 10,
            right: 30,
            left: window.innerWidth <= 500 ? -20 : 0,
            bottom: 60,
          }}
        >
          <XAxis
            dataKey="name"
            stroke="0"
            style={{ fontSize: "14px" }}
            padding={{ left: 30, right: 10 }}
          />
          <YAxis stroke="0" style={{ fontSize: "14px" }} />
          <Tooltip content={CustomTooltip} />
          <Line
            type="monotone"
            dataKey="students"
            stroke="#5EC4C4"
            strokeWidth={3}
            activeDot={{ r: 7 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}

export default BarChart
